import type { LinkProps } from '@mui/material/Link';

import { mergeClasses } from 'minimal-shared/utils';

import Link from '@mui/material/Link';
import { styled } from '@mui/material/styles';

import { RouterLink } from 'src/routes/components';

import { logoClasses } from './classes';
import { CONFIG } from '../../global-config';

// ----------------------------------------------------------------------

export type LogoProps = LinkProps & {
  isSingle?: boolean;
  disabled?: boolean;
};

export function Logo({
  sx,
  disabled,
  className,
  href = '/',
  isSingle = true,
  ...other
}: LogoProps) {
  /*
    * OR using local (public folder)
    *
    const singleLogo = (
      <img
        alt="Single logo"
        src={`${CONFIG.assetsDir}/logo/logo-single.svg`}
        width="100%"
        height="100%"
      />
    );
    *
    */

  const singleLogo =
    import.meta.env.VITE_STATE_NAME === 'mch' ? (
      <img
        alt="MCH logo"
        src={`${CONFIG.assetsDir}/logo/logo-mch.svg`}
        style={{ width: '100%', height: '100%', objectFit: 'contain' }}
      />
    ) : (
      <img
        alt="Full logo"
        src={`${CONFIG.assetsDir}/logo/logo-single.png`}
        width="100%"
        height="100%"
      />
    );
  const fullLogo =
    import.meta.env.VITE_STATE_NAME === 'mch' ? (
      <img
        alt="MCH logo"
        src={`${CONFIG.assetsDir}/logo/logo-mch.svg`}
        style={{ width: '100%', height: '100%', objectFit: 'contain' }}
      />
    ) : (
      <img
        alt="Full logo"
        src={`${CONFIG.assetsDir}/logo/logo-full.png`}
        width="100%"
        height="100%"
      />
    );

  return (
    <LogoRoot
      component={RouterLink}
      href={href}
      aria-label="Logo"
      underline="none"
      className={mergeClasses([logoClasses.root, className])}
      sx={[
        {
          width: import.meta.env.VITE_STATE_NAME === 'mch' ? 80 : 40,
          height: 40,
          ...(!isSingle && {
            width: import.meta.env.VITE_STATE_NAME === 'mch' ? 120 : 102,
            height: 36,
          }),
          ...(disabled && { pointerEvents: 'none' }),
        },
        ...(Array.isArray(sx) ? sx : [sx]),
      ]}
      {...other}
    >
      {isSingle ? singleLogo : fullLogo}
    </LogoRoot>
  );
}

// ----------------------------------------------------------------------

const LogoRoot = styled(Link)(() => ({
  flexShrink: 0,
  color: 'transparent',
  display: 'inline-flex',
  verticalAlign: 'middle',
}));
